import actions from './actions'

export default function ContractsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CONTRACT:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.SELECT_CONTRACT:
      return {
        ...state,
        selected: action.payload,
        loading: false,
      }
    case actions.OPEN_COPY_CONTRACT:
      return {
        ...state,
        copying: true,
        copySuccess: false,
        loading: false,
      }
    case actions.CLOSE_COPY_CONTRACT:
      return {
        ...state,
        copying: false,
        copySuccess: false,
        loading: false,
      }
    case actions.COPY_CONTRACT_RECIEVED:
      return {
        ...state,
        copying: action.result == null ? state.copying : false,
        copySuccess: action.result != null,
        loading: false,
      }
    case actions.UNSELECT_CONTRACT_RECIEVED:
      return {
        ...state,
        selected: null,
        loading: false,
      }
    case actions.EDIT_CONTRACT:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CONTRACT:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CONTRACT:
      return {
        ...state,
        editing: { contractID: 0 },
        loading: false,
        saveSuccess: false,
      }
    // The save's answer. This case did not exist: the project window never learned that
    // the save had finished and kept spinning. Success closes the window (saveSuccess);
    // an error keeps it open with the entered data (saveFailed tells the page to stop
    // the spinner) - the reason is already shown by the request helper.
    case actions.SAVE_CONTRACT_RECIEVED:
      if (action.result === null || action.result === undefined) {
        return {
          ...state,
          loading: false,
          saveSuccess: false,
          saveFailed: (state.saveFailed || 0) + 1,
        }
      }
      return {
        ...state,
        editing: { contractID: 0 },
        loading: false,
        saveSuccess: true,
      }
    // NOTE: "A || B || C" evaluates to A - only CREATE_CONTRACT_RECIEVED reaches this
    // case. Left as it is: matching UPDATE/DELETE as well would switch on code that has
    // never run.
    case actions.CREATE_CONTRACT_RECIEVED ||
      actions.UPDATE_CONTRACT_RECIEVED ||
      actions.DELETE_CONTRACT_RECIEVED:
      return {
        ...state,
        editing: { contractID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
